import Heading from 'components/generic/Heading'
import MainContainer from 'components/generic/MainContainer'
import { CONTACT_US_FULL_URL, CONTACT_US_HREF, PRIVACY_POLICY_HREF } from 'constants/global'
import React from 'react'
import styles from './privacyPolicy.module.scss'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
const TermsAndConditions = () => {
  return (
    <MainContainer>
      <div className={styles.privacyPolicy}>
        <div className={styles.sections}>
          <Heading>ITF World Tennis Number Terms and Conditions</Heading>
          <section>
            <h3>PLAYER ACCESS AND USAGE AGREEMENT</h3>
            <p>
              <strong>LAST AMENDED: 23/09/21</strong>
            </p>
            <p>
              <strong>
                PLEASE READ THESE TERMS AND CONDITIONS (&ldquo;THESE TERMS&rdquo;) CAREFULLY BEFORE
                USING THIS WEBSITE AT{' '}
                <a
                  href='https://www.worldtennisnumber.com'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  worldtennisnumber.com
                </a>{' '}
                (&ldquo;THIS WEBSITE&rdquo;) AS THEY INCLUDE IMPORTANT TERMS WHICH APPLY TO YOU.
              </strong>
            </p>
            <p>
              <strong>
                BY USING THIS WEBSITE, YOU CONFIRM THAT YOU ACCEPT THESE TERMS AND THAT YOU AGREE TO
                COMPLY WITH THEM. IF YOU DO NOT AGREE TO THESE TERMS, YOU MUST NOT USE THIS WEBSITE.{' '}
              </strong>
            </p>
            <p>
              <strong>
                IF YOU ARE USING THIS WEBSITE ON BEHALF OF A COMPANY, ORGANISATION, OR OTHER ENTITY,
                THEN YOU REPRESENT AND WARRANT THAT YOU ARE AN AUTHORISED REPRESENTATIVE OF THE
                ENTITY WITH THE AUTHORITY TO BIND THE ENTITY TO THESE TERMS, AND THAT YOU AGREE TO
                THESE TERMS ON THE ENTITY&rsquo;S BEHALF.
              </strong>
            </p>
          </section>
          <section>
            <h3>WHO WE ARE AND HOW TO CONTACT US&nbsp;</h3>
            <ul>
              <li>
                This website is operated by ITF Limited (&ldquo;<strong>we</strong>&rdquo; &ldquo;
                <strong>our</strong>&rdquo; &ldquo;<strong>us</strong>&rdquo;). We are registered in
                the Bahamas and have our registered office at PO Box N272 Nassau, Bahamas.
              </li>
              <li>
                If you wish to contact us for any reason please email{' '}
                <a href='mailto:support@wtn.zendesk.com'>support@wtn.zendesk.com</a>.
              </li>
            </ul>
          </section>
          <div>
            <Table className={styles.termsAndConditionsTable}>
              <Thead>
                <Tr>
                  <Th className={styles.bg}>
                    <p>
                      <strong>Term</strong>
                    </p>
                  </Th>
                  <Th className={styles.bg}>
                    <p>
                      <strong>National Association</strong>
                    </p>
                  </Th>
                  <Th className={styles.bg}>
                    <p>
                      <strong>Player/Other</strong>
                    </p>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td>
                    <p>OTHER TERMS THAT MAY APPLY TO YOU&nbsp;</p>
                  </Td>
                  <Td>
                    <p>
                      1.1. The following additional terms also apply to your use of this website:
                    </p>
                    <p>
                      (a) Our <a href={PRIVACY_POLICY_HREF}>Privacy Notice</a>, which sets out how
                      we may use your personal information.
                    </p>
                    <p>
                      (b) Our{' '}
                      <a
                        href='https://www.itftennis.com/en/about-us/cookies/'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        {' '}
                        Cookie Policy{' '}
                      </a>
                      , which sets out information about the cookies on this website.
                    </p>
                    <p>
                      1.2. Whenever you make use of a feature that allows you to upload content to
                      this website, you must comply with the WTN Platform Rules [
                      <strong>see </strong>
                      <a href='#appendix-2'>
                        <strong>Appendix 2</strong>
                      </a>
                      ], which sets out the rules governing the data which can be uploaded onto this
                      website, including verification, correction and amendment obligations.
                    </p>
                  </Td>
                  <Td>
                    <p>
                      1.1. The following additional terms also apply to your use of this website:
                    </p>
                    <p>
                      (c) Our <a href={PRIVACY_POLICY_HREF}>Privacy Notice </a>, which sets out how
                      we may use your personal information.
                    </p>
                    <p>
                      (d) Our{' '}
                      <a
                        href='https://www.itftennis.com/en/about-us/cookies/'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        {' '}
                        Cookie Policy{' '}
                      </a>
                      , which sets out information about the cookies on this website.
                    </p>
                    <p>
                      1.2. Whenever you make use of a feature that allows you to upload content to
                      this website, or to make contact with other users of this website, you must
                      comply with the WTN Platform Rules [<strong>see</strong>
                      <a href='#appendix-1'>
                        <strong> Appendix 1</strong>
                      </a>
                      ], which sets out the rules governing the data which can be uploaded onto this
                      website, including verification, correction and amendment obligations.
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>YOUR LICENCE TO US</p>
                  </Td>
                  <Td>
                    <p>
                      2.1. The terms of the licence that you give to us are set out in full in the
                      License and Usage Agreement executed between the ITF and you.
                    </p>
                  </Td>
                  <Td>
                    <p>
                      2.1. You retain all of your ownership rights in any content you upload, share
                      or post on this website (&ldquo;<strong>your content</strong>&rdquo;) but you
                      grant to us a perpetual, worldwide, non-exclusive, royalty-free,
                      sub-licensable, transferable licence to host, use, copy, reproduce, translate,
                      modify, create derivative works of, distribute, and/or display, your content,
                      without any further consent, notice and/or compensation to you or others for
                      the purposes of: (a) providing this website; (b) creating and providing the
                      World Tennis Number and related services; and (c) fostering and growing the
                      sport of tennis worldwide and promoting the sport of tennis at all levels.
                    </p>
                    <p>
                      2.2. You acknowledge and agree that your content may be made available to the
                      general public and other users (including other tennis players and the staff
                      of tennis clubs and national associations) in line with the functionality of
                      this website, which we may change from time to time.
                    </p>
                    <p>
                      2.3. The licence above in paragraph 2.1 is not intended to affect any of your
                      rights under data protection law or under our{' '}
                      <a href={PRIVACY_POLICY_HREF}>Privacy Notice </a>, including your rights to
                      request that we restrict or stop using personal data about you.
                    </p>
                    <p>
                      2.4. You can at any time remove certain specific content by deleting it or you
                      can remove your content generally by closing your user account with us. When
                      you delete content or close your account it will no longer be visible to other
                      users but we may need to retain a copy to satisfy any legal, regulatory, tax,
                      accounting or reporting requirements we are subject to, or if there is a
                      complaint, or if we reasonably believe there is a prospect of litigation in
                      respect to our relationship with you. In such cases we will retain your
                      content for no longer than is necessary for the purpose we have retained it.
                      We will also retain your match results content to maintain the integrity of
                      the algorithm that drives the Word Tennis Number. In addition, other copies
                      may have been made by other users before you deleted the content or closed
                      your user account and you acknowledge that we are not responsible for those
                      copies. The licence granted above in paragraph 2.1 shall continue to exist
                      until we and those users who retain copies, have deleted all copies.
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>ACCEPTABLE USE</p>
                  </Td>
                  <Td>
                    <p>
                      3.1. You may use this website only for lawful purposes. You may not use this
                      website: (a) in any way that breaches any applicable local, national or
                      international law or regulation; (b) in any way that is unlawful or
                      fraudulent, or has any unlawful or fraudulent purpose or effect; (c) for the
                      purpose of harming or attempting to harm minors in any way; (d) to bully,
                      insult, intimidate or humiliate any person; (e) to send, knowingly receive,
                      upload, download, use or re-use any material which does not comply with
                      paragraph 5 below; (f) to transmit, or procure the sending of, any unsolicited
                      or unauthorised advertising or promotional material or any other form of
                      similar solicitation (spam).
                    </p>
                    <p>
                      3.2. You will ensure that the content (as defined in paragraph 3.1 above): (a)
                      is accurate (where facts are stated); (b) is genuinely held (where opinions or
                      preferences are given); and (c) complies with all applicable local, national
                      or international laws or regulations.
                    </p>
                  </Td>
                  <Td>
                    <p>
                      3.1. You may use this website only for lawful purposes. You may not use this
                      website: (a) in any way that breaches any applicable local, national or
                      international law or regulation; (b) in any way that is unlawful or
                      fraudulent, or has any unlawful or fraudulent purpose or effect; (c) for the
                      purpose of harming or attempting to harm minors in any way; (d) to bully,
                      insult, intimidate or humiliate any person; (e) to send, knowingly receive,
                      upload, download, use or re-use any material which does not comply with
                      paragraph 5 below; (f) to transmit, or procure the sending of, any unsolicited
                      or unauthorised advertising or promotional material or any other form of
                      similar solicitation (spam).
                    </p>
                    <p>
                      3.2. You will ensure that your content (as defined in paragraph 3.1 above):
                      (a) is accurate (where facts are stated); (b) is genuinely held (where
                      opinions or preferences are given); and (c) complies with all applicable
                      local, national or international laws or regulations.
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>CONTENT RULES</p>
                  </Td>
                  <Td>
                    <p>
                      4.1. You may submit information about matches played by members of your
                      National Tennis Association in accordance with{' '}
                      <a href='#appendix-2'>Appendix 2</a>.
                    </p>
                    <p>
                      4.2. You will ensure that the content (as defined in paragraph 3.1 above): (a)
                      is not defamatory of any person; (b) is not obscene, offensive, hateful or
                      inflammatory; (c) does not bully, insult, intimidate or humiliate; (d) does
                      not promote sexually explicit material; (e) does not include child sexual
                      abuse material; (f) does not promote violence; (g) does not promote
                      discrimination based on race, sex, religion, nationality, disability, sexual
                      orientation or age; (h) does not infringe any copyright, database right or
                      trade mark of any other person; (i) is not likely to deceive any person; (j)
                      does not breach any legal duty owed to a third party, such as a contractual
                      duty or a duty of confidence; (k) does not promote any illegal activity; (l)
                      is not in contempt of court; (m) does not threaten, abuse or invade
                      another&rsquo;s privacy, or cause annoyance, inconvenience or needless
                      anxiety; (n) is not likely to harass, upset, embarrass, alarm or annoy any
                      other person; (o) does not impersonate any person, or misrepresent your
                      identity or that of your National Tennis Association or affiliation with any
                      person; (p) does not give the impression that the content emanates from any
                      other person or entity, if this is not the case; (q) does not advocate,
                      promote, incite any party to commit, or assist any unlawful or criminal act
                      such as (by way of example only) copyright infringement or computer misuse;
                      (r) does not contain a statement which you know or believe, or have reasonable
                      grounds for believing, that members of the public to whom the statement is, or
                      is to be, published are likely to understand as a direct or indirect
                      encouragement or other inducement to the commission, preparation or
                      instigation of acts of terrorism; or (s) does not contain any advertising or
                      promote any services or web links to other sites.
                    </p>
                    <p>
                      4.3. We have the right to disclose your identity to any third party who is
                      claiming that any content posted or uploaded by you to this website
                      constitutes a violation of their intellectual property rights, or of their
                      right to privacy.
                    </p>
                    <p>
                      4.4. You warrant on an ongoing basis that you have all permissions, licences,
                      consents and authorisations necessary to upload the content to this website
                      and enable it to be used as anticipated in these terms.
                    </p>
                    <p>
                      4.5. You warrant that the content complies with the standards set out in this
                      paragraph 4, and you will be responsible for any loss or damage we suffer as a
                      result of this warranty.&nbsp;
                    </p>
                    <p>4.6. You are solely responsible for securing and backing up the content.</p>
                    <p>4.7. We do not store terrorist content.</p>
                  </Td>
                  <Td>
                    <p>
                      4.1. You may submit information about matches you have played with other
                      registered users of this website. You acknowledge and agree that when you
                      register to use this website, other users (including players that you have
                      played matches with and organisers of tennis competitions you have
                      participated in) may submit details about the matches you have played.
                    </p>
                    <p>
                      4.2. You will ensure that your content (as defined in paragraph 3.1 above):
                      (a) is not defamatory of any person; (b) is not obscene, offensive, hateful or
                      inflammatory; (c) does not bully, insult, intimidate or humiliate; (d) does
                      not promote sexually explicit material; (e) does not include child sexual
                      abuse material; (f) does not promote violence; (g) does not promote
                      discrimination based on race, sex, religion, nationality, disability, sexual
                      orientation or age; (h) does not infringe any copyright, database right or
                      trade mark of any other person; (i) is not likely to deceive any person; (j)
                      does not breach any legal duty owed to a third party, such as a contractual
                      duty or a duty to keep information confidential; (k) does not promote any
                      illegal activity; (l) is not in contempt of court; (m) does not threaten,
                      abuse or invade another&rsquo;s privacy, or cause annoyance, inconvenience or
                      needless anxiety; (n) is not likely to harass, upset, embarrass, alarm or
                      annoy any other person; (o) does not impersonate any person, or misrepresent
                      your identity or affiliation with any person; (p) does not give the impression
                      that your content comes from any other person, if this is not the case; (q)
                      does not support, promote, incite any party to commit, or assist any unlawful
                      or criminal act such as (by way of example only) copyright infringement or
                      computer misuse; (r) does not contain a statement which you know or believe,
                      or have reasonable grounds for believing, that members of the public to whom
                      the statement is, or is to be, published are likely to understand as a direct
                      or indirect encouragement or other inducement to the commission, preparation
                      or instigation of acts of terrorism; or (s) does not contain any advertising
                      or promote any services or web links to other sites.
                    </p>
                    <p>
                      4.3. We have the right to disclose your identity to any third party who is
                      claiming that any content posted or uploaded by you to this website
                      constitutes a violation of their intellectual property rights, or of their
                      right to privacy.
                    </p>
                    <p>
                      4.4. You warrant on an ongoing basis that you have all permissions, licences,
                      consents and authorisations necessary to upload your content to this website
                      and enable it to be used as anticipated in these terms.
                    </p>
                    <p>
                      4.5. You warrant that your content complies with the standards set out in this
                      paragraph 4, and you will be responsible for any loss or damage we suffer as a
                      result of this warranty. We have the right to remove any posting you make on
                      this website if, in our opinion, your post does not comply with the standards
                      set out in this paragraph 4.
                    </p>
                    <p>4.6. You are solely responsible for securing and backing up your content.</p>
                    <p>4.7. We do not store terrorist content.</p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>USER-GENERATED CONTENT IS NOT APPROVED BY US</p>
                  </Td>
                  <Td>
                    <p>
                      5.1. This website includes information and materials uploaded by other users
                      of the site. This information and these materials have not been verified or
                      approved by us. The views expressed by other users on this website do not
                      represent our views or values.
                    </p>
                    <p>
                      5.2. If you wish to complain about content uploaded by other users please
                      contact us on <a href={CONTACT_US_HREF}>{CONTACT_US_FULL_URL}</a>.
                    </p>
                  </Td>
                  <Td>
                    <p>
                      5.1. This website includes information and materials uploaded by other users
                      of the site. This information and these materials have not been verified or
                      approved by us. The views expressed by other users on this website do not
                      represent our views or values.
                    </p>
                    <p>
                      5.2. If you wish to complain about content uploaded by other users please
                      contact us on <a href={CONTACT_US_HREF}>{CONTACT_US_FULL_URL}</a>.
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>INTELLECTUAL PROPERTY RIGHTS</p>
                  </Td>
                  <Td>
                    <p>
                      6.1. Please see the License and Usage Agreement executed between the ITF and
                      you regarding the Intellectual Property Rights in the content.
                    </p>
                  </Td>
                  <Td>
                    <p>
                      6.2. Except for the rights you retain in your content (see paragraph 2.1
                      above), we or our licensors are the owner or the licensee of all intellectual
                      property rights in this website, and in the material published on it. Those
                      works are protected by copyright laws and treaties around the world. All such
                      rights are reserved. Our status (and that of any identified contributors) as
                      the authors of content on this website must always be acknowledged.
                    </p>
                    <p>
                      6.3. Except for the rights you retain in your content (see paragraph 2.1
                      above), you have no intellectual property rights in, or to, this website other
                      than the right to use them in accordance with these terms.
                    </p>
                    <p>
                      6.4. You acknowledge that you have no right to have access to this website in
                      source-code form and that any feedback you provide and any resulting
                      invention, modification, improvement in this website will remain exclusively
                      our property.&nbsp;
                    </p>
                    <p>
                      6.5. If any enhancements, derivatives, changes, modifications, alterations or
                      adaptations of or to this website, are made, created, developed, or acquired
                      by you (whether or not authorised under these terms), all intellectual
                      property rights in and to such works shall belong exclusively to us.
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>HOW YOU MAY USE THIS WEBSITE AND THE MATERIALS ON IT</p>
                  </Td>
                  <Td>
                    <p>
                      7.1. You may only use this website in accordance with the License and Usage
                      Agreement that <a href='#appendix-2'>Appendix 2.</a> You must not use this
                      website or any of its content for any other purpose (including commercial
                      purposes) without obtaining a licence to do so from us or our licensors.
                    </p>
                    <p>
                      7.2. You must not, except as permitted by your National Tennis Association
                      pursuant to the License and Usage Agreement:
                    </p>
                    <p>
                      (a) rent, lease, transfer, sell, resell, assign, distribute, sub-license, time
                      share, loan, provide, or otherwise make available, this website (or any of the
                      content comprising it) in any form, in whole or in part to any person;
                    </p>
                    <p>
                      (b) copy this website (or any of the content comprising it), except as part of
                      your normal use or where it is necessary for the purpose of back-up or
                      operational security;
                    </p>
                    <p>
                      (c) translate, merge, adapt, vary, alter or modify this website (or any of the
                      content comprising it), nor permit this website (or any of the content
                      comprising it) to be combined with, or become incorporated in, any other
                      programs, except as necessary to use this website as permitted in these terms;
                    </p>
                    <p>
                      (d) disassemble, de-compile, attempt to derive the source code of, reverse
                      engineer or create derivative works based on this website (or any of the
                      content comprising it) nor attempt to do any such things, except to the extent
                      that such actions cannot be prohibited under applicable copyright law;
                    </p>
                    <p>
                      (e) provide or otherwise make available this website (or any of the content
                      comprising it) (including object and source code), in any form to any person;
                    </p>
                    <p>
                      (f) use this website (or any of the content comprising it) in any unlawful
                      manner, for any unlawful purpose, or in any manner inconsistent with these
                      terms, or act fraudulently or maliciously, for example, by hacking into or
                      inserting malicious code, such as viruses, or harmful data, into this website
                      (or any of the content comprising it) or any operating system;
                    </p>
                    <p>
                      (g) access or use this website from or in any jurisdiction in which such
                      access or use is prohibited for any reason;
                    </p>
                    <p>
                      (h) infringe our intellectual property rights or those of any third party in
                      relation to your use of this website (or any of the content comprising it),
                      including by the submission of any material (to the extent that such use is
                      not licensed by these terms);
                    </p>
                    <p>
                      (i) use this website (or any of the content comprising it) in a way that could
                      damage, disable, disrupt, overburden, impair or compromise the integrity or
                      performance of this website, our systems or security or interfere with other
                      users;
                    </p>
                    <p>
                      (j) collect or harvest any information or data from this website (or any of
                      the content comprising it) or our systems or attempt to decipher any
                      transmissions to or from the servers running this website (or any of the
                      content comprising it);
                    </p>
                    <p>
                      (k) attempt to gain unauthorised access to this website or related systems, or
                      disable, deactivate, or circumvent (or attempt to do any of these) any
                      security protocols, systems, passwords, access controls, technologies, or
                      methodologies associated with this website (or any of the content comprising
                      it);
                    </p>
                    <p>
                      (l) copy, reproduce, scrape, transfer or disclose to any third party,
                      transform, amend or store the data on this website, except as part of your
                      normal use or where it is necessary for the purpose of back-up or operational
                      security;
                    </p>
                    <p>
                      (m) generate or collect any meta data, whether structural or descriptive, or
                      any derivative or aggregated data, information or content whatsoever through
                      your monitoring, access or use of this website;
                    </p>
                    <p>
                      (n) link to or frame this website without our prior written consent which, if
                      given, may be withdrawn at any time at our sole discretion; or
                    </p>
                    <p>
                      (o) disseminate performance related information relating to this website (or
                      any of the content comprising it).&nbsp;
                    </p>
                    <p>
                      7.3. You are responsible for (a) the payment of any charges levied by your own
                      third party telecommunications providers for accessing and making use of this
                      website and (b) any costs you incur in obtaining and using any hardware,
                      software or other equipment required to access and make use of this website.
                    </p>
                    <p>
                      7.4. You shall use up-to-date, industry-standard and comprehensive anti-virus
                      software to seek to prevent the introduction of any harmful program
                      (including, without limitation any viruses, Trojan horses, worms and spyware)
                      or any other harmful programs or similar computer code designed to adversely
                      affect the operation of any computer software or hardware into this website.
                    </p>
                    <p>
                      7.5. You shall notify us immediately if you becomes aware of any unauthorised
                      access or use of this website or any other actual or potential breach of
                      security in relation to this website and provide such reasonable assistance to
                      us with regard to abating such access, use or breach as we shall reasonably
                      request.
                    </p>
                    <p>
                      7.6. You must ensure that all persons who access this website through your
                      internet connection are aware of these terms and that they comply with them.
                    </p>
                  </Td>
                  <Td>
                    <p>
                      7.1. You may only use this website for your own personal and private use, to
                      determine your individual tennis playing level and identify opponents and
                      competitions of an appropriate standard with a view to having access to more
                      competitive and enjoyable playing opportunities. You must not use this website
                      or any of its content for any other purpose (including commercial purposes)
                      without obtaining a licence to do so from us or our licensors.
                    </p>
                    <p>7.2. You must not:</p>
                    <p>
                      (a) rent, lease, transfer, sell, resell, assign, distribute, sub-license, time
                      share, loan, provide, or otherwise make available, this website (or any of the
                      content comprising it) in any form, in whole or in part to any person without
                      prior written consent from us;
                    </p>
                    <p>
                      (b) copy this website (or any of the content comprising it), except as part of
                      your normal use or where it is necessary for the purpose of back-up or
                      operational security;
                    </p>
                    <p>
                      (c) translate, merge, adapt, vary, alter or modify this website (or any of the
                      content comprising it), nor permit this website (or any of the content
                      comprising it) to be combined with, or become incorporated in, any other
                      programs, except as necessary to use this website as permitted in these terms;
                    </p>
                    <p>
                      (d) disassemble, de-compile, attempt to derive the source code of, reverse
                      engineer or create derivative works based on this website (or any of the
                      content comprising it) nor attempt to do any such things, except to the extent
                      that such actions cannot be prohibited under applicable copyright law;
                    </p>
                    <p>
                      (e) provide or otherwise make available this website (or any of the content
                      comprising it) (including object and source code), in any form to any person;
                    </p>
                    <p>
                      (f) use this website (or any of the content comprising it) in any unlawful
                      manner, for any unlawful purpose, or in any manner inconsistent with these
                      terms, or act fraudulently or maliciously, for example, by hacking into or
                      inserting malicious code, such as viruses, or harmful data, into this website
                      (or any of the content comprising it) or any operating system;
                    </p>
                    <p>
                      (g) access or use this website from or in any jurisdiction in which such
                      access or use is prohibited for any reason;
                    </p>
                    <p>
                      (h) infringe our intellectual property rights or those of any third party in
                      relation to your use of this website (or any of the content comprising it),
                      including by the submission of any material (to the extent that such use is
                      not licensed by these terms);
                    </p>
                    <p>
                      (i) use this website (or any of the content comprising it) in a way that could
                      damage, disable, disrupt, overburden, impair or compromise the integrity or
                      performance of this website, our systems or security or interfere with other
                      users;
                    </p>
                    <p>
                      (j) collect or harvest any information or data from this website (or any of
                      the content comprising it) or our systems or attempt to decipher any
                      transmissions to or from the servers running this website (or any of the
                      content comprising it);
                    </p>
                    <p>
                      (k) attempt to gain unauthorised access to this website or related systems, or
                      disable, deactivate, or circumvent (or attempt to do any of these) any
                      security protocols, systems, passwords, access controls, technologies, or
                      methodologies associated with this website (or any of the content comprising
                      it);
                    </p>
                    <p>
                      (l) copy, reproduce, scrape, transfer or disclose to any third party,
                      transform, amend or store the data on this website, except as part of your
                      normal use or where it is necessary for the purpose of back-up or operational
                      security. For completeness, you shall be entitled to deal with any data you
                      upload to this website in any manner whatsoever;
                    </p>
                    <p>
                      (m) generate or collect any meta data, whether structural or descriptive, or
                      any derivative or aggregated data, information or content whatsoever through
                      your monitoring, access or use of this website;
                    </p>
                    <p>
                      (n) link to or frame this website without our prior written consent which, if
                      given, may be withdrawn at any time at our sole discretion; or
                    </p>
                    <p>
                      (o) disseminate performance related information relating to this website (or
                      any of the content comprising it).&nbsp;
                    </p>
                    <p>
                      7.3. You are responsible for (a) the payment of any charges levied by your own
                      third party telecommunications providers for accessing and making use of this
                      website and (b) any costs you incur in obtaining and using any hardware,
                      software or other equipment required to access and make use of this website.
                    </p>
                    <p>
                      7.4. You shall use up-to-date, industry-standard and comprehensive anti-virus
                      software to seek to prevent the introduction of any harmful program
                      (including, without limitation any viruses, Trojan horses, worms and spyware)
                      or similar computer code designed to adversely affect the operation of any
                      computer software or hardware into this website.
                    </p>
                    <p>
                      7.5. You shall notify us immediately if you becomes aware of any unauthorised
                      access or use of this website or any other actual or potential breach of
                      security in relation to this website and provide such reasonable assistance to
                      us with regard to abating such access, use or breach as we shall reasonably
                      request.
                    </p>
                    <p>
                      7.6. You must ensure that all persons who access this website through your
                      internet connection are aware of these terms and that they comply with them.
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>YOU MUST KEEP YOUR ACCOUNT DETAILS SAFE&nbsp;</p>
                  </Td>
                  <Td>
                    <p>
                      You agree to comply with the System Rules, at{' '}
                      <a href='#appendix-2'>Appendix 2</a>, regarding password protection and other
                      security requirements for the safe access and use of the website.
                    </p>
                  </Td>
                  <Td>
                    <p>
                      8.1. If you choose, or you are provided with, a user identification code,
                      password or any other piece of information as part of our security procedures,
                      you must treat such information as confidential. You must not disclose it to
                      any third party.
                    </p>
                    <p>
                      8.2. It is your responsibility to ensure that any information you provide to
                      us is complete, accurate and that it remains up to date. You acknowledge that
                      any error in your account information may prevent us from providing this
                      website to you or providing you with an accurate World Tennis Number.&nbsp;
                    </p>
                    <p>
                      8.3. You must not use another person&rsquo;s user account or allow another
                      person to use your user account. If you know or suspect that anyone other than
                      you knows your user identification code or password, you must promptly notify
                      us at <a href={CONTACT_US_HREF}>{CONTACT_US_FULL_URL}</a> and provide us with
                      any information which we may reasonably require to verify your identity or
                      deactivate, suspend, or cancel your user account.
                    </p>
                    <p>
                      8.4. You are responsible for maintaining the security of your account and
                      shall at all times remain responsible for the use of your user account and the
                      activity on it, whether or not the activity was authorised by you.
                    </p>
                    <p>
                      8.5. We have the right (but not the obligation) to monitor and screen your use
                      of this website, investigate any suspected violation of these terms and take
                      any action we deem appropriate, including reporting any activity we suspect to
                      be in violation of any applicable law to the appropriate authorities and
                      co-operating with such authorities.
                    </p>
                    <p>
                      8.6. You will, at our request, provide us, the police or any authorized body
                      with such co-operation as they may reasonably require in order to investigate
                      any suspected fraud, illegal or unlawful activity in connection with your user
                      account.&nbsp;
                    </p>
                    <p>
                      8.7. We have the right to prevent or restrict your access to this website
                      and/or disable any user identification code or password and/or remove any
                      content uploaded by you to this website, at any time including: (a) if we
                      reasonably believe that you have you breached these terms; (b) if we are
                      required to by law; or (c) if we reasonably believe that your use of this
                      website (or any of the content comprising it) may infringe or violate the
                      rights of a third party or subject us to civil or criminal liability or
                      reputational harm.
                    </p>
                    <p>
                      8.8. You agree to comply with Section C of the Player System Rules regarding
                      password protection and other security requirements for the safe access and
                      use of the website
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>WE MAY CHANGE, SUSPEND OR WITHDRAW THIS WEBSITE&nbsp;</p>
                  </Td>
                  <Td>
                    <p>9.1. Subject to any prevailing terms of the License and Usage Agreement:</p>
                    <p>
                      (1) This website is made available free of charge on a non-commercial basis.
                    </p>
                    <p>
                      (2) We may update and change this website from time to time, with or without
                      notice to you, to reflect changes to our products, our users&rsquo; needs and
                      our priorities or for any other reason.
                    </p>
                    <p>
                      9.2. This website is made available to you on an 'as is' and 'as available'
                      basis only. We do not guarantee that this website, or any content on it, will
                      always be available or will be uninterrupted. We may suspend or withdraw or
                      restrict the availability of all or any part of this website, with or without
                      notice to you, and for any reason, including business and operational reasons.
                    </p>
                  </Td>
                  <Td>
                    <p>
                      9.1. This website is made available free of charge on a non-commercial basis.
                      We may update and change this website from time to time, with or without
                      notice to you, to reflect changes to our products, our users&rsquo; needs and
                      our priorities or for any other reason.
                    </p>
                    <p>
                      9.2. This website is made available to you on an 'as is' and 'as available'
                      basis only. We do not guarantee that this website, or any content on it, will
                      always be available or will be uninterrupted. We may suspend or withdraw or
                      restrict the availability of all or any part of this website, with or without
                      notice to you, and for any reason, including business and operational reasons.
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>DO NOT RELY ON INFORMATION ON THIS WEBSITE&nbsp;</p>
                  </Td>
                  <Td>
                    <p>
                      10.1. The content on this website is provided for general information only. It
                      is not intended to amount to advice on which you should rely.
                    </p>
                    <p>
                      10.2. You acknowledge and agree that the information on this website is
                      provided by, or sourced from, third parties, including you, and we are not
                      able to verify such data ourselves. Subject to any prevailing terms in the
                      License and Usage Agreement, we make no representations, warranties or
                      guarantees, whether express or implied, that the content on this website is
                      accurate, complete or up to date.
                    </p>
                  </Td>
                  <Td>
                    <p>
                      10.3. The content on this website is provided for general information only. It
                      is not intended to amount to advice on which you should rely. You must obtain
                      professional or specialist advice before taking, or refraining from, any
                      action on the basis of the content on this website.
                    </p>
                    <p>
                      10.4. You acknowledge and agree that the information on this website is
                      provided by, or sourced from, third parties and we are not able to verify such
                      data ourselves. Accordingly, we make no representations, warranties or
                      guarantees, whether express or implied, that the content on this website is
                      accurate, complete or up to date.
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>WE ARE NOT RESPONSIBLE FOR THIRD PARTY SERVICES&nbsp;</p>
                  </Td>
                  <Td>
                    <p>
                      11.1. Where this website contains links to other websites and resources
                      provided by third parties, these links are provided for your information only.
                      Such links should not be interpreted as approval by us of those linked
                      websites or information you may obtain from them. We have no control over the
                      contents of those websites or resources
                    </p>
                  </Td>
                  <Td>
                    <p>
                      11.1. Where this website contains links to other websites and resources
                      provided by third parties, these links are provided for your information only.
                      Such links should not be interpreted as approval by us of those linked
                      websites or information you may obtain from them. We have no control over the
                      contents of those websites or resources
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>OUR RESPONSIBILITY FOR LOSS OR DAMAGE SUFFERED BY YOU&nbsp;</p>
                  </Td>
                  <Td>
                    <p>
                      12.1. We do not exclude or limit in any way our liability to you where it
                      would be unlawful to do so. This includes liability for death or personal
                      injury caused by our negligence or the negligence of our employees, agents or
                      subcontractors and for fraud or fraudulent misrepresentation.
                    </p>
                    <p>
                      12.2. Subject to paragraph 12.1: (a) we exclude all implied conditions,
                      warranties, representations or other terms that may apply to this website or
                      any content on it; and (b) we will not be liable to you for any loss or
                      damage, whether in contract, tort (including negligence), breach of statutory
                      duty, or otherwise, even if foreseeable, arising under or in connection with:
                      (i) use of, or inability to use, this website; or (ii) use of or reliance on
                      any content displayed on our site. In particular, we will not be liable for:
                      (i) loss of profits or revenue (whether direct or indirect); (ii) loss of
                      opportunity or anticipated savings (whether direct or indirect); (iii) loss of
                      goodwill or reputation (whether direct or indirect); (iv) loss or corruption
                      of data (whether direct or indirect); or (v) special, indirect or
                      consequential loss or damage; even if advised of the possibility of such loss
                      or damage.
                    </p>
                    <p>
                      12.3. This clause 12 shall be read in conjunction with the terms of the
                      License and Usage Agreement. In the case of any inconsistencies, the terms of
                      the License and Usage Agreement shall prevail.
                    </p>
                  </Td>
                  <Td>
                    <p>
                      12.1. We do not exclude or limit in any way our liability to you where it
                      would be unlawful to do so. This includes liability for death or personal
                      injury caused by our negligence or the negligence of our employees, agents or
                      subcontractors and for fraud or fraudulent misrepresentation.
                    </p>
                    <p>
                      12.2. Subject to paragraph 12.1: (a) we exclude all implied conditions,
                      warranties, representations or other terms that may apply to this website or
                      any content on it; and (b) we will not be liable to you for any loss or
                      damage, whether in contract, tort (including negligence), breach of statutory
                      duty, or otherwise, even if foreseeable, arising under or in connection with:
                      (i) use of, or inability to use, this website; or (ii) use of or reliance on
                      any content displayed on our site. In particular, we will not be liable for:
                      (i) loss of profits or revenue (whether direct or indirect); (ii) loss of
                      opportunity or anticipated savings (whether direct or indirect); (iii) loss of
                      goodwill or reputation (whether direct or indirect); (iv) loss or corruption
                      of data (whether direct or indirect); or (v) special, indirect or
                      consequential loss or damage; even if advised of the possibility of such loss
                      or damage.
                    </p>
                    <p>
                      12.3. You acknowledge and agree that we are making this website available for
                      access and use by you free of charge for the benefit of the sport of tennis
                      worldwide generally and to develop and promote tennis at all levels and
                      therefore, subject to paragraph 12.1, our maximum aggregate liability under or
                      in connection with our agreement with you (whether in contract, tort including
                      negligence or otherwise) shall be limited to a nominal amount of &pound;100.00
                      (one hundred Pounds Sterling). You further acknowledge and agree that this is
                      a reasonable and fair allocation of risk taking into account the amount being
                      paid by you for access to, and use of, this website.
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>WE ARE NOT RESPONSIBLE FOR VIRUSES AND YOU MUST NOT INTRODUCE THEM</p>
                  </Td>
                  <Td>
                    <p>
                      13.1. We do not guarantee that this website will be secure or free from bugs
                      or viruses.
                    </p>
                    <p>
                      13.2. You are responsible for configuring your information technology,
                      computer programmes and platform to access this website. You should use your
                      own virus protection software.
                    </p>
                    <p>
                      13.3. You must not knowingly misuse this website to transmit any data, send or
                      upload any material that contains any harmful program (including, without
                      limitation viruses, Trojan horses, worms, and spyware) or any other harmful
                      programs or similar computer code designed to adversely affect the operation
                      of any computer software or hardware. You must not attempt to gain
                      unauthorised access to this website, the server on which this website is
                      stored or any server, computer or database connected to this website. You must
                      not attack this website via a denial-of-service attack or a distributed
                      denial-of service attack. By breaching this provision, you would commit a
                      criminal offence under the Computer Misuse Act 1990. We will report any such
                      breach to the relevant law enforcement authorities and we will co-operate with
                      those authorities by disclosing your identity to them. In the event of such a
                      breach, your right to use this website will cease immediately.
                    </p>
                  </Td>
                  <Td>
                    <p>
                      13.1. We do not guarantee that this website will be secure or free from bugs
                      or viruses.
                    </p>
                    <p>
                      13.2. You are responsible for configuring your information technology,
                      computer programmes and platform to access this website. You should use your
                      own virus protection software.
                    </p>
                    <p>
                      13.3. You must not knowingly misuse this website to transmit any data, send or
                      upload any material that contains any harmful program (including, without
                      limitation viruses, Trojan horses, worms, and spyware) or similar computer
                      code designed to adversely affect the operation of any computer software or
                      hardware. You must not attempt to gain unauthorised access to this website,
                      the server on which this website is stored or any server, computer or database
                      connected to this website. You must not attack this website via a
                      denial-of-service attack or a distributed denial-of service attack. By
                      breaching this provision, you would commit a criminal offence under the
                      Computer Misuse Act 1990. We will report any such breach to the relevant law
                      enforcement authorities and we will co-operate with those authorities by
                      disclosing your identity to them. In the event of such a breach, your right to
                      use this website will cease immediately.
                    </p>
                  </Td>
                </Tr>
                <Tr>
                  <Td>
                    <p>WE MAY MAKE CHANGES TO THESE TERMS&nbsp;</p>
                  </Td>
                  <Td>
                    <p>
                      14. We may amend these terms from time to time. Every time you wish to use
                      this website, please check these terms to ensure you understand the terms that
                      apply at that time
                    </p>
                  </Td>
                  <Td>
                    <p>
                      14. We may amend these terms from time to time. Every time you wish to use
                      this website, please check these terms to ensure you understand the terms that
                      apply at that time
                    </p>
                  </Td>
                </Tr>
              </Tbody>
            </Table>
          </div>
          <section>
            <h3>OTHER IMPORTANT TERMS</h3>
            <ol>
              <li>
                We may transfer our rights and obligations under these terms to another
                organisation. You may only transfer your rights or your obligations under these
                terms to another person if we agree in writing.
              </li>
              <li>
                No other person, other than you or us, shall have any right to enforce these terms.
              </li>
              <li>
                Each of the paragraphs of these terms operates separately. If any court or relevant
                authority decides that any of them are unlawful, the remaining paragraphs will
                remain in full force and effect.
              </li>
              <li>
                Even if we delay in enforcing these terms (or any part of them), we can still
                enforce them later. If we do not insist immediately that you do anything you are
                required to do under these terms, or if we delay in taking steps against you in
                respect of your breaking our agreement, that will not mean that you do not have to
                do those things and it will not prevent us taking steps against you at a later date.
                If we do waive a default by you, we will only do so in writing, and that will not
                mean that we will automatically waive any later default by you.
              </li>
            </ol>
          </section>
          <section>
            <h3>WHICH LAWS APPLY TO THIS CONTRACT AND WHERE YOU MAY BRING LEGAL PROCEEDINGS</h3>
            <ol>
              <li>
                These terms and any dispute or claim arising out of or in connection with them or
                their subject matter or formation (including non-contractual disputes or claims)
                shall be governed by and construed in accordance with English law.
              </li>
              <li>
                You and we irrevocably agree that the courts of England and Wales shall have
                exclusive jurisdiction to settle any dispute or claim arising out of or in
                connection with these terms or their subject matter or formation (including
                non-contractual disputes or claims).
              </li>
            </ol>
          </section>
          <section id='appendix-1'>
            <p>
              <strong>Appendix 1</strong>
            </p>
            <p>
              <strong>
                <u>ITF WORLD TENNIS NUMBER SYSTEM RULES &ndash; PLAYERS/OTHER</u>
              </strong>
            </p>
            <section id='_A._AGE_RESTRICTIONS'>
              <h3>A. AGE RESTRICTIONS</h3>
              <ol>
                <li>
                  You will only be eligible for an ITF World Tennis Number if you are 9 years or
                  older.
                </li>
              </ol>
            </section>
            <section>
              <h3>B. UPDATING YOUR DETAILS</h3>
              <ol>
                <li>You will need to contact your association to update your details.</li>
                <li>
                  To ensure your information is up to date you will only be able to update
                  it&nbsp;through your association, they will then inform ITF World Tennis Number of
                  the changes and these will be reflected on your account.
                </li>
              </ol>
            </section>
            <section>
              <h3>C. REPORTING INCORRECT DATA</h3>
              <ol>
                <li>
                  ITF World Tennis Number is powered by a confidential, tested and objective
                  mathematical calculation.
                </li>
              </ol>
            </section>
            <section>
              <h3>D. RESULTS</h3>
              <ol>
                <li>
                  If you believe that match data uploaded by a&nbsp;association to ITF World Tennis
                  Number is incorrect you have the right to appeal.
                </li>
                <li>
                  To appeal incorrect data please contact the association and follow their appeal
                  process. Your&nbsp;association shall investigate the alleged error. If an error is
                  identified (whether through the omission of data or an incorrect input)
                  your&nbsp;association shall notify you and correct the error. If no error is
                  identified, your&nbsp;association shall explain this to you.
                </li>
                <li>
                  It will be the&nbsp;association&rsquo;s responsibility to update any incorrect
                  data and reload it to ITF World Tennis Number. ITF World Tennis Number will not
                  have the ability to correct any results on behalf of the associations.
                </li>
                <li>
                  If a change is made to your match result this will be reloaded into ITF World
                  Tennis Number and your Number will recalculate on the next update.
                </li>
              </ol>
            </section>
          </section>
          <section id='appendix-2'>
            <p>
              <strong>Appendix 2</strong>
            </p>
            <p>
              <strong>
                <u>ITF WORLD TENNIS NUMBER SYSTEM RULES &ndash; NATIONAL ASSOCIATIONS</u>
              </strong>
            </p>
            <section id='_A._SYSTEM_ADMINISTRATORS'>
              <h3>A. SYSTEM ADMINISTRATORS &ndash; ACCESS TO THE SYSTEM</h3>
              <ol>
                <li>
                  Do not share your username or password or allow any other person to use your
                  account, it is your responsibility to ensure the safety of your account.
                </li>
                <li>
                  ITF World Tennis Number will monitor the use of all accounts and if an account
                  hasn&rsquo;t been used for 45 days access will be revoked.
                </li>
              </ol>
              <p>
                The Super User at your&nbsp;association will be able to reactivate a revoked account
                if you wish to login again.
              </p>
              <ol>
                <li>
                  If you think your account has been compromised, please reset your password and
                  inform the ITF World Tennis Number Help Desk immediately.
                </li>
              </ol>
            </section>
            <section>
              <h3>B. UPLOADING MATCH AND PLAYER DATA</h3>
              <ol>
                <li>
                  Associations may only upload results data to the ITF World Tennis Number for
                  tournaments that they own or which they are the official sanctioning authority.
                  This helps to ensure that match results for the same tournament are not uploaded
                  by multiple organisations and avoids creating duplicate matches in the system or
                  potentially posting different scores for the same match. Only the recognised
                  &lsquo;owner&rsquo; of each event will be permitted to upload the official
                  results.
                </li>
                <li>
                  All international events will be uploaded by the ITF only &ndash; including ITF
                  Circuits, ATP Tour, WTA Tour, Grand Slams, Davis Cup, Fed Cup, and Olympics.
                </li>
                <li>
                  All tournament and player records must have a unique ID that distinguishes them
                  within your entire database.
                </li>
                <li>
                  The primary way of uniquely identifying each a player across all&nbsp;association
                  databases is by their globally unique Tennis ID (or IPIN). Results should,
                  therefore, include a player&rsquo;s Tennis IDs so that ITF World Tennis Number can
                  easily and accurately identify them and prevent duplicate players being created in
                  the system.
                </li>
                <li>
                  If a set of tournament results is uploaded which contains players who do not
                  already exist in the ITF World Tennis Number database (i.e. they do not already
                  have a Tennis ID), a new player record and Tennis ID will be created for each of
                  them. Please check that any new players that you are uploading do not already
                  exist in ITF World Tennis Number before submitting results so that duplicate
                  player records and multiple player profiles (with different ITF World Tennis
                  Numbers) are not created during the results upload process.
                </li>
                <li>
                  Do not upload results with large number of new players who do not already exist in
                  the ITF World Tennis Number database. A maximum of 20 new players can be included
                  in each set of tournament results uploaded to the database. If you need to add a
                  larger number of new players to the ITF World Tennis Number system at one time,
                  this must be done via the bulk player import process. Please contact the ITF World
                  Tennis Number Help Desk for assistance with bulk player creation.
                </li>
                <li>
                  Results should only be uploaded for completed tournaments. Please do not upload
                  results for events that are still in progress.
                </li>
                <li>
                  Always upload the complete set of results data for each tournament or event. Do
                  not upload individual draws or results for single rounds. Each time you upload
                  results for a tournament any existing data for that tournament in ITF World Tennis
                  Number is deleted and replaced by the new set of data provided.
                </li>
                <li>
                  Results can be uploaded at any time but it is recommended that they are uploaded
                  in a batch at the same time every week.
                </li>
                <li>
                  Do not re-upload results for a completed tournament which is already in ITF World
                  Tennis Number unless it is to correct data errors.
                </li>
                <li>
                  Match and player data can only be submitted to ITF World Tennis Number by
                  associations. This is to protect the integrity of the Numbers being produced.
                  Please contact ITF World Tennis Number if you need to authorise a third party or
                  results service provided to upload your data on your behalf.
                </li>
                <li>
                  Nations should upload all match results (singles and doubles) for players from the
                  1st January 2016 to date.
                </li>
                <li>
                  ITF World Tennis Number will only be able to process data for players aged 9 years
                  or older who have a match record from 1st January 2016.
                </li>
                <li>
                  All data uploaded to ITF World Tennis Number should be provided in the Tennis Open
                  Data Standards (TODS) format.
                </li>
                <li>
                  There shall be regular monitoring of the platform to identify incorrect or false
                  data.
                </li>
                <li>
                  If you find duplicate player records or duplicate results data in the ITF World
                  Tennis Number system please report the full details to the ITF World Tennis Number
                  Help Desk.
                </li>
                <li>
                  If incorrect data is found the ITF may suspend without notice the User's access
                  to, and use of,&nbsp;ITF World Tennis Number at any time. The ITF can ask the User
                  to conduct periodic checks of a sample of the data inputted at any time.
                </li>
              </ol>
            </section>
          </section>
        </div>
      </div>
    </MainContainer>
  )
}

export default TermsAndConditions
